import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from 'components/layout'
import HeroPersonal from 'sections/hero/HeroPersonal';
import LazyWrapper from '../components/lazyWrapper/LazyWrapper';
import AboutPersonal from '../sections/about/AboutPersonal';
import Services from 'sections/services/Services.js'
import PortfolioThree from 'sections/portfolio/PortfolioThree.js'
import ContactPersonal from 'sections/contact/ContactPersonal.js'
import Testimonials from 'sections/testimonials/TestimonialsThree.js'
import VideoLinks from '../sections/work/VideoLinks'

class Index extends React.Component {

  render() {

    const { site } = this.props.data

    return (
      <div>
        <Helmet>
          <title>{site.meta.title}</title>
          <meta name="description" content={site.meta.description} />
        </Helmet>
        <Layout
          isHome={true}
          sections={['home', 'bio', 'services', 'portfolio', 'music', 'testimonials', 'contact']}
        >
          <HeroPersonal />
          <LazyWrapper component={AboutPersonal} />
          <LazyWrapper component={Services} />
          <LazyWrapper component={PortfolioThree} />
          <LazyWrapper component={VideoLinks} />
          <LazyWrapper component={Testimonials} />
          <LazyWrapper component={ContactPersonal} />
        </Layout>
      </div>
    )
  }
}

export default Index

export const personalQuery = graphql`
  query {
    site {
      meta: siteMetadata {
        title
        description
      }
    }
  }
`